// Fonction utilitaire pour formater le libellé "HONORAIRES REÇU" en "HONORAIRES REÇU CABINET"
export const formatLibelleForDisplay = (libelle) => {
  if (!libelle) return '-';
  const libelleUpper = libelle.toUpperCase();
  // Remplacer "HONORAIRES REÇU" par "HONORAIRES REÇU CABINET" pour l'affichage
  // Vérifier si le libellé contient "HONORAIRES REÇU" (avec ou sans accent, avec ou sans S)
  if (libelleUpper.includes('HONORAIRES REÇU') || libelleUpper.includes('HONORAIRES RECU') || libelleUpper.includes('HONORAIRE RECU') || libelleUpper.includes('HONORAIRE REÇU')) {
    // Si le libellé contient déjà "CABINET", ne rien faire
    if (libelleUpper.includes('CABINET')) {
      return libelle;
    }
    // Remplacer toutes les occurrences de "HONORAIRES REÇU" par "HONORAIRES REÇU CABINET"
    let formatted = libelle;
    // Remplacer au début
    formatted = formatted.replace(/^(HONORAIRES REÇU|HONORAIRES RECU|HONORAIRE RECU|HONORAIRE REÇU)/i, 'HONORAIRES REÇU CABINET');
    // Remplacer ailleurs si pas déjà remplacé
    if (!formatted.includes('CABINET')) {
      formatted = formatted.replace(/(HONORAIRES REÇU|HONORAIRES RECU|HONORAIRE RECU|HONORAIRE REÇU)/gi, 'HONORAIRES REÇU CABINET');
    }
    return formatted;
  }
  return libelle;
};

